import classNames from 'classnames';
import React from 'react';

interface IProps {
  className?: string;
  children: React.ReactNode;
}

export const CardList: React.FC<IProps> = (props) => {
  return (
    <ul
      role="list"
      className={classNames(
        'divide-y divide-gray-100 overflow-hidden bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl',
        props.className,
      )}>
      {props.children}
    </ul>
  );
};

export const CardListItem: React.FC<IProps> = (props) => {
  return (
    <li className="relative flex justify-between gap-x-6 px-4 py-5 hover:bg-gray-50 sm:px-6">
      {props.children}
    </li>
  );
};
